import dynamic from "next/dynamic";

export const SafetyTips = dynamic(() => import("./SafetyTips"), {
  ssr: false
});
